import React, { useState } from "react";
import classes from "./collaboration.module.scss";

import {
  Button,
  Col,
  Input,
  message,
  Modal,
  Row,
  Switch,
  Table,
  Typography,
} from "antd";
import { MailOutlined, PlusOutlined } from "@ant-design/icons";
const { Title } = Typography;

const Collaboration = () => {
  // Sample data to simulate the backend response
  const [dataSource, setDataSource] = useState([
    {
      id: 1,
      userName: "john_doe",
      email: "john_doe_1_2_3@gmail.com",
      firstName: "John",
      lastName: "Doe",
      role: "Admin",
      status: "Active",
    },
    {
      id: 2,
      userName: "jane_smith",
      email: "jane@gmail.com",
      firstName: "Jane",
      lastName: "Smith",
      role: "User",
      status: "Active",
    },
    {
      id: 3,
      userName: "john_doe",
      email: "john_doe_1_2_3@gmail.com",
      firstName: "John",
      lastName: "Doe",
      role: "Admin",
      status: "Active",
    },
    {
      id: 4,
      userName: "jane_smith",
      email: "jane@gmail.com",
      firstName: "Jane",
      lastName: "Smith",
      role: "User",
      status: "Inactive",
    },
  ]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [emailAddress, setEmailAddress] = useState("");
  const [emailAddressList, setEmailAddressList] = useState([]);

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const handleAddEmailToList = () => {
    if (emailAddress) {
      if (validateEmail(emailAddress)) {
        if (
          emailAddressList.includes(emailAddress) ||
          dataSource.some((data) => data.email === emailAddress)
        ) {
          message.error("Email address already added");
          return;
        }
        setEmailAddressList([...emailAddressList, emailAddress]);
        setEmailAddress("");
      } else {
        message.error("Invalid email address");
      }
    }
  };

  const handleAddEmailToDataSource = () => {
    const newUsers = emailAddressList.map((email, index) => ({
      id: dataSource.length + index + 1,
      userName: email.split("@")[0],
      email: email,
      firstName: "",
      lastName: "",
      role: "User",
      status: "Active",
    }));
    setDataSource([...dataSource, ...newUsers]);
    setIsModalOpen(false);
    setEmailAddress("");
    setEmailAddressList([]);
    message.success("User(s) invited successfully");
  };

  const handleOk = () => {
    if (!emailAddressList.length) {
      message.error("Please add email address to invite");
      return;
    }
    handleAddEmailToDataSource();
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setEmailAddress("");
    setEmailAddressList([]);
  };

  const handleUpdateStatus = (rowData) => {
    const updatedData = dataSource.map((data) => {
      if (data.id === rowData.id) {
        return {
          ...data,
          status: data.status === "Active" ? "Inactive" : "Active",
        };
      }
      return data;
    });
    setDataSource(updatedData);
    rowData.status === "Active"
      ? message.success("User Deactivated Successfully")
      : message.success("User Activated Successfully");
  };

  // Define the columns for the Ant Design table
  const columns = [
    {
      title: "Username",
      dataIndex: "userName",
      key: "userName",
    },
    {
      title: "Email Address",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "First Name",
      dataIndex: "firstName",
      key: "firstName",
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      key: "lastName",
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
    },
    {
      title: "Active",
      key: "status",
      render: (record) => (
        <Switch
          checked={record.status === "Active"}
          size="small"
          onChange={() => {
            handleUpdateStatus(record);
          }}
        />
      ),
    },
  ];

  return (
    <>
      <div className={classes.header}>
        <Row gutter={[8, 8]} align={"middle"}>
          <Col md={12} sm={24}>
            <Title level={4} style={{ marginTop: 0, marginBottom: 0 }}>
              Users List
            </Title>
          </Col>
          <Col md={12} sm={24} style={{ textAlign: "right" }}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => setIsModalOpen(true)}
            >
              Invite Users
            </Button>
          </Col>
        </Row>
      </div>
      <Table
        columns={columns}
        dataSource={dataSource ?? []}
        rowKey="id"
        size="small"
        // scroll={{ x: 1500 }} // Enable horizontal and vertical scrolling
      />

      <Modal
        title="Invite Users"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Invite"
      >
        <div style={{ minHeight: "200px", margin: "20px 0px" }}>
          <Row gutter={5} align={"middle"}>
            <Col md={20} sm={20}>
              <Input
                prefix={<MailOutlined />}
                placeholder="Type email address to add..."
                value={emailAddress}
                onChange={(e) => setEmailAddress(e.target.value)}
              />
            </Col>
            <Col md={4} sm={4} style={{ textAlign: "right" }}>
              <Button
                type="primary"
                style={{ width: "100%" }}
                onClick={handleAddEmailToList}
                disabled={!emailAddress}
              >
                Add
              </Button>
            </Col>
          </Row>
          <ul>
            {emailAddressList.map((email, index) => (
              <li key={index}>{email}</li>
            ))}
          </ul>
        </div>
      </Modal>
    </>
  );
};

export default Collaboration;
